import { Dayjs } from 'dayjs';

import { ContactSearchRequestDto, ContactStatusDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { Override } from '@/utils/Override.utilityType.ts';

export type ContactsSearchFormModel = Override<
  ContactSearchRequestDto,
  {
    customerFullTextSearchInput: string | null;
    fullTextSearchInput: string | null;
    isAlreadyInCustomer: SelectSearchOptionModel<boolean> | null;
    isAlreadyInSupplier: SelectSearchOptionModel<boolean> | null;
    lastContactedFrom?: Dayjs | null;
    lastContactedTo?: Dayjs | null;
    ownerIds: SelectSearchOptionModel[];
    status: SelectSearchOptionModel<ContactStatusDto> | null;
  }
>;

export const initialContactsSearchFormModel = (params: {
  isAlreadyInCustomer?: SelectSearchOptionModel<boolean>;
}): ContactsSearchFormModel => {
  const { isAlreadyInCustomer } = params;
  return {
    customerFullTextSearchInput: '',
    fullTextSearchInput: '',
    isAlreadyInCustomer: isAlreadyInCustomer ?? null,
    isAlreadyInSupplier: null,
    lastContactedFrom: null,
    lastContactedTo: null,
    ownerIds: [],
    status: { label: 'Aktywny', value: ContactStatusDto.Active },
  };
};
